import { UsersModal, LiteUsersModal, AdvisorUsersModal } from './UsersModalV2.jsx';

const UsersModalMap = {
  // UsersModal,
  // LiteUsersModal,
  UsersModal,
};

export default UsersModalMap;
